<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="{ ...$attrs, ...attrs }"
        v-on="{ ...$listeners, ...on }"
        :color="copiedToClipboard ? 'primary' : ''"
        small
        :class="iconClass"
        @click.stop="copyContentToClipboard()"
        >{{
          !copiedToClipboard ? "mdi-content-copy" : "mdi-clipboard-check"
        }}</v-icon
      >
    </template>
    <span class="text-capitalize">Copy to clipboard</span>
    <div ref="contrainer"></div>
  </v-tooltip>
</template>

<script>
import { bus } from "@/main";
export default {
  props: {
    textTobeCopied: String,
    iconClass: String,
  },
  data() {
    return {
      copiedToClipboard: false,
    };
  },
  methods: {
    copyContentToClipboard() {
      const storage = document.createElement("textarea");
      storage.value = this.textTobeCopied.trim();
      let child = this.$refs.contrainer.appendChild(storage);
      storage.select();
      storage.setSelectionRange(0, 99999);
      document.execCommand("copy");
      this.$refs.contrainer.removeChild(child);
      bus.$emit("showToastMessage", {
        message: `${this.textTobeCopied.trim()} Copied to clipboard!`,
        color: "success",
        timeout: 2000,
      });
      this.copiedToClipboard = true;
      setTimeout(() => {
        this.copiedToClipboard = false;
      }, 2000);
    },
  },
};
</script>

<style></style>
